export class AppFileUpload extends HTMLElement {
  static get observedAttributes() {
    return ["label", "accept", "multiple", "disabled", "helper", "error"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const label = this.getAttribute("label") || "Upload de Documentos";
    const accept = this.getAttribute("accept") || "*/*";
    const multiple = this.hasAttribute("multiple");
    const disabled = this.hasAttribute("disabled");
    const helper = this.getAttribute("helper") || "Arraste e solte arquivos aqui ou clique para selecionar";
    const error = this.getAttribute("error") || "";

    const id = `file-upload-${Math.random().toString(36).substring(2, 9)}`;

    this.innerHTML = `
      <div class="form-group">
        <span class="form-label">${label}</span>
        <label for="${id}" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 24px 16px; border: 1px dashed var(--color-border-default); border-radius: var(--radius-sm); background-color: var(--color-surface-secondary); cursor: ${disabled ? "not-allowed" : "pointer"}; text-align: center; transition: border-color var(--transition-fast);">
          <input
            id="${id}"
            type="file"
            accept="${accept}"
            ${multiple ? "multiple" : ""}
            ${disabled ? "disabled" : ""}
            style="display: none;"
          />
          <span style="font-size: 1.5rem; margin-bottom: 8px;">📄</span>
          <span style="font-size: 0.8125rem; font-weight: 500; color: var(--color-text-primary);">${helper}</span>
          <span style="font-size: 0.6875rem; color: var(--color-text-muted); margin-top: 4px;">Formatos aceitos: ${accept}</span>
        </label>
        ${error ? `<span class="form-error">${error}</span>` : ""}
      </div>
    `;
  }
}

if (!customElements.get("app-file-upload")) {
  if (!customElements.get("app-file-upload")) {
    customElements.define("app-file-upload", AppFileUpload);
  }
}
